import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import settings from './modules/settings'
import getters from './getters'
import app from './modules/app'
import dict from './modules/dict'
import flow from './modules/flow'
import process from "./modules/process";

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        settings,
        app,
        dict,
        flow,
        process
    },
    getters
})

export default store